import { ElNotification } from 'element-plus'
import NotifyOfSending from '@/components/main-table/cell-briefing/NotifyOfSending.vue'
import i18n from '@/lang'
import { h } from 'vue'

const createNotification = (type, message, title, options = {}) => {
  title = title || i18n.global.t(`notification.${type}`)
  ElNotification({
    position: 'bottom-right',
    duration: 3000,
    showClose: false,
    type,
    title,
    message,
    ...options
  })
}

export default {
  methods: {
    notifyInfo (message, title, options) {
      createNotification('info', message, title, options)
    },
    notifySuccess (message, title, options) {
      createNotification('success', message, title, options)
    },
    notifyError (message, title, options) {
      createNotification('error', message, title, { ...options, showClose: true, duration: 0 })
    },
    notifyWarning (message, title, options) {
      createNotification('warning', message, title, { ...options, showClose: true, duration: 0 })
    },
    notifyOfSendingEmail (payload) {
      const { success, errors } = payload || {}
      const html = h(NotifyOfSending, { res: JSON.stringify(payload) })

      if (success > 0 && !errors) {
        createNotification(
          'success',
          html,
          null
        )
      } else {
        createNotification(
          'warning',
          html,
          null,
          { showClose: true, duration: 0 }
        )
      }
    }
  }
}
